"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoticeInformLevelEnum = void 0;
/**
 * Уровень информирования о событии
 */
var NoticeInformLevelEnum;
(function (NoticeInformLevelEnum) {
  /** выключено */
  NoticeInformLevelEnum[NoticeInformLevelEnum["disabled"] = 0] = "disabled";
  /** включено */
  NoticeInformLevelEnum[NoticeInformLevelEnum["enabled"] = 1] = "enabled";
  /** включено, но бесшумно */
  NoticeInformLevelEnum[NoticeInformLevelEnum["muted"] = 3] = "muted";
})(NoticeInformLevelEnum = exports.NoticeInformLevelEnum || (exports.NoticeInformLevelEnum = {}));
